import { ReactNode } from 'react';
import { toast as sonnerToast } from 'sonner';

export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}

/**
 * Toast service wrapper around Sonner library.
 * This abstraction allows easy replacement of the underlying toast library if needed.
 */
export const toastService = {
  /**
   * Creates and displays a success toast notification
   * @param content - React node or string to display in the toast
   * @param type
   */
  createToast: (content: ReactNode, type?: ToastType) => {

    type = type || ToastType.SUCCESS;

    if (type === ToastType.SUCCESS) {
      sonnerToast.success(content, {
        duration: 5000,
      });
    } else if (type === ToastType.WARNING) {
      sonnerToast.warning(content, {
        duration: 5000,
      });
    } else if (type === ToastType.ERROR) {
      sonnerToast.error(content, {
        duration: 5000,
      });
    }
  },
};
